import { Typography } from "antd";
import { twMerge } from "tailwind-merge";

export default function MainTitle({ children, className, ...rest }) {
    return <Typography.Text className={twMerge("text-2xl sm:text-3xl 2xl:text-4xl font-bold leading-tight text-center max-w-[30ch] text-primary", className)} {...rest}>{children}</Typography.Text>
}